import { render, staticRenderFns } from "./CleanupManagement.vue?vue&type=template&id=369bccf0&scoped=true"
import script from "./CleanupManagement.vue?vue&type=script&lang=js"
export * from "./CleanupManagement.vue?vue&type=script&lang=js"
import style0 from "./CleanupManagement.vue?vue&type=style&index=0&id=369bccf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369bccf0",
  null
  
)

export default component.exports